export default __webpack_public_path__ + "static/media/unicorn.3caa0ed4.png";